var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  global.Manifest =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(json) {
      _classCallCheck(this, _class);

      this.json = json; // TODO: Implement validation RULES:
      // 1. has no doi -> HAVE TO own raw value or at least one formula
      // 2. has no MIME -> HAVE TO own doi or at least one formula
    }

    _createClass(_class, [{
      key: "ToString",
      value: function ToString() {
        return JSON.stringify(this.json);
      }
    }, {
      key: "get_mime",
      value: function get_mime() {
        var result = {
          status: "Has no MIME",
          data: null
        };

        if (this.json.hasOwnProperty("MIME")) {
          result.status = "ok";
          result.data = this.json.MIME;
        }

        return result;
      }
    }, {
      key: "get_size",
      value: function get_size() {
        var result = {
          status: "Has no size",
          data: null
        };

        if (this.json.hasOwnProperty("size")) {
          result.status = "ok";
          result.data = this.json.size;
        }

        return result;
      }
    }, {
      key: "get_raw_value",
      value: function get_raw_value() {
        var result = {
          status: "Has no raw",
          data: []
        };

        if (this.json.hasOwnProperty("raw")) {
          result.status = "ok";
          result.data = new TextEncoder("utf-8").encode(this.json.raw);
        }

        return result;
      }
    }, {
      key: "get_doi",
      value: function get_doi() {
        var result = {
          status: "ok",
          data: []
        };

        if (this.json.hasOwnProperty("doi")) {
          for (var doi in this.json.doi) {
            result.data.push(this.json.doi[doi]);
          }
        } else result.status = "Has no DOI";

        return result;
      }
    }, {
      key: "get_formulas",
      value: function get_formulas() {
        var _this = this;

        var result = {
          status: "",
          data: []
        };

        if (this.json.hasOwnProperty("formulas")) {
          this.json.formulas.forEach(function (json_formula) {
            try {
              result.data.push(new global.Formula(json_formula, _this));
            } catch (error) {
              result.status += "Error creating formula (" + error + ") ";
            }
          });
        }

        if ("" === result.status) result.status = "ok";
        return result;
      }
    }]);

    return _class;
  }();
})();